const calculateScrollbarWidth = (function calculateScrollbarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    return calculateScrollbarWidth;
})();

document.addEventListener('DOMContentLoaded', calculateScrollbarWidth); 
window.addEventListener('resize', calculateScrollbarWidth);
window.addEventListener('load', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:render', calculateScrollbarWidth);
document.documentElement.addEventListener('turbo:frame-render', calculateScrollbarWidth);
